import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, OnInit } from '@angular/core';
import { UntypedFormControl, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ApiService } from '../services/api/api.service';
import { CustomvalidationService } from '../services/servicescustomvalidation.service';

@Component({
  selector: 'app-forgotpassword',
  templateUrl: './forgotpassword.component.html',
  styleUrls: ['./forgotpassword.component.css'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        padding: '.75rem 1.25rem',
        margin: '0 0 1rem 0'
      })),
      state('out', style({
        opacity: '0',
        height: '0px',
        width: '0px'
      })),
      transition('in <=> out', animate('0.1s'))
    ])
  ]
})
export class ForgotpasswordComponent implements OnInit {
  hidePass = true;
  hidePass2 = true;
  reset1 = false;
  reset2 = true;
  reset3 = true;
  errorDisplay : string;
  passwordInput: string;
  confirmpasswordInput: string;
  userPasswordCheck: UntypedFormControl;
  currentYear:any;

  constructor(private customValidator: CustomvalidationService,public router: Router,private apiService : ApiService){ 
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear();
  }

  ngOnInit(): void {
    this.errorDisplay = 'out';
    // this.userPasswordCheck = new UntypedFormControl(this.user.M_PASSWORD, [Validators.compose([Validators.required, this.customValidator.patternValidator()])]);
  }

  login(): any
  {
    // this.apiService.updatepassword(username, this.passwordInput).subscribe((data)=>
    // {
    //   this.setErrTextDisplay('out');
    //   return this.router.navigate(['/login'],{replaceUrl: true,});
    // },
    // (error)=>
    // {
    //   this.setErrTextDisplay('in');
    // });
    return this.router.navigate(['/login'],{replaceUrl: true,});
  }

  setErrTextDisplay(display: string): void {
    this.errorDisplay = display;
  }

  verifyPasswords() {
    if (this.passwordInput !== this.confirmpasswordInput) {
      this.setErrTextDisplay('in');
    } else {
      this.login();
    }
  }
}